<div class="page-content-wrapper">
  <app-sidebar-layout [showMenuToggle]="true">
    <div class="table-header">
      <div class="card-main-title">
        <app-tab-main [links]="tabs"></app-tab-main>
      </div>
      <div class="table-actions">
        <div class="search-input-div search-input-container">
          <div class="input-group">
            <button type="submit" class="input-group-addon">
              <label class="label-icon" for="search">
                <i class="material-icons mb-0">search</i>
              </label>
            </button>
            <div class="input-field">
              <input type="search" #searchField class="search-input mb-0"
                [placeholder]="'Search Organization' | translate" />
              </div>
            </div>
          </div>

          <div class="sort-field">
            <button type="button" class="btn" [title]="'Filter results' | translate">
              <img src="assets/images/sorting.svg" alt="sorting" class="sorting-icon" />
            </button>
          </div>
        </div>
      </div>

      <section class="card-style-sec p-20 d-flex justify-content-center">
        <div class="org-section">
          @for (org of organizationsTree; track trackById($index, org)) {
            <div class="org-tree-root">
              <app-hierarchy-node class="ground-level" [node]="org"></app-hierarchy-node>
            </div>
          }
        </div>
      </section>
    </app-sidebar-layout>
  </div>